// FormScreen.tsx

'use client';

import DynamicFormClient from '../dynamicForm';
import { JSONFormSchema } from '../types/types';

export const DynamicClientPage = ({ schema, uiSchema, id, name }: JSONFormSchema) => {
  return <DynamicFormClient schema={schema} uiSchema={uiSchema} id={id} name={name} />
};
